import * as React from 'react';
import { createComponent } from '@lit/react';
import { UniversalNavChangelogWC } from './universal-nav-changelog.wc';

export const UniversalNavChangelog = createComponent({
  tagName: UniversalNavChangelogWC.tagname,
  elementClass: UniversalNavChangelogWC,
  react: React,
});
